module.exports = __webpack_public_path__ + "img/mit.6548b076.svg";